import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import type { EnvironmentProviders, Provider } from '@angular/core';
import { withTiming } from './server-timing';

export function provideEnvironmentSpecificProviders(): Array<EnvironmentProviders | Provider> {
    return [provideHttpClient(withFetch(), withInterceptors([withTiming]))];
}
